export default __webpack_public_path__ + "static/media/hornsicon.7f5f127c.png";